//- Filters
// Large Filter
let lFilters = $('.std_filters');
let calTypeI;
if (lFilters.length) {
  let dI = $(lFilters).find('.std_filters--input-di')[0];
  let dO = $(lFilters).find('.std_filters--input-do')[0];
  let pN = $(lFilters).find('.std_filters--input-pn')[0];
  let oP = $(lFilters).find('.std_filters--options')[0];
  let bT = $(lFilters).find('.std_filters--btn')[0];
  //...
  //console.log(dI, dO, pN, oP, bT);
  //console.log(oP);

  // Close all panels
  function closeAllPanels() {
    let panels = $(lFilters).find('.std_filter--panel');
    panels.each(function () {
      let p = this;
      p.opacity = '';
      p.style.display = '';
      //...
      if (p.classList.contains('std_filter--calender')) {
        let calP = $('.std_filter--calender')[0];
        let calPF = $(calP).find('.from_date')[0];
        let calPT = $(calP).find('.to_date')[0];
        //...
        let inDI = $('.std_filters--input-di');
        let inDO = $('.std_filters--input-do');
        let iHol = $(inDI).find('.std_filters--input--pholder')[0];
        let iArr = $(inDI).find('.std_filters--input--arrow')[0];
        let oHol = $(inDO).find('.std_filters--input--pholder')[0];
        let oArr = $(inDO).find('.std_filters--input--arrow')[0];
        //...
        inDI[0].style.background = '#FFF';
        inDO[0].style.background = '#FFF';
        //...
        iHol.style.background = '';
        iArr.style.transform = '';
        oHol.style.background = '';
        oArr.style.transform = '';
        //...
        calPF.style.opacity = 0;
        calPF.style.display = '';
        calPT.style.opacity = 0;
        calPT.style.display = '';
      }
      if (p.classList.contains('std_filter--pers')) {
        let opC = $(lFilters).find('.std_filters--input-pn')[0];
        let pHol = $(opC).find('.std_filters--input--pholder')[0];
        let pArr = $(opC).find('.std_filters--input--arrow')[0];
        opC.style.background = '#FFF';
        pHol.style.background = '';
        pArr.style.transform = '';
      }
      if (p.classList.contains('std_filter--options')) {
        oP.style.background = '#FFF';
      }
    });
  }

  // Date picker From
  let calP = $('.std_filter--calender')[0];
  let calPF = $(calP).find('.from_date')[0];
  let calPT = $(calP).find('.to_date')[0];
  dI.onclick = function () {
    // Set Type
    calTypeI = false;
    //...
    let pHol = $(dI).find('.std_filters--input--pholder')[0];
    let arr = $(dI).find('.std_filters--input--arrow')[0];
    if (calPF.style.display === 'block') {
      $('.std_filters--inner').removeClass('shadow');
      calPF.style.opacity = 0;
      arr.style.transform = '';
      setTimeout(function () {
        //dI.style.background = '';
        pHol.style.background = '';
        //...
        calPF.style.display = '';
      }, 200);
    } else {
      closeAllPanels();
      $('.std_filters--inner').addClass('shadow');
      calPF.style.display = 'block';
      arr.style.transform = 'rotate(180deg)';
      setTimeout(function () {
        dI.style.background = '#F5F6F5';
        pHol.style.background = '#F5F6F5';
        //...
        calPF.style.opacity = 1;
      }, 10);
    }
  };

  // Date picker To
  dO.onclick = function () {
    // Set Type
    calTypeI = true;
    //...
    let pHol = $(dO).find('.std_filters--input--pholder')[0];
    let arr = $(dO).find('.std_filters--input--arrow')[0];
    if (calPT.style.display === 'block') {
      $('.std_filters--inner').removeClass('shadow');
      calPT.style.opacity = 0;
      arr.style.transform = '';
      setTimeout(function () {
        //dO.style.background = '';
        pHol.style.background = '';
        //...
        calPT.style.display = '';
      }, 200);
    } else {
      closeAllPanels();
      $('.std_filters--inner').addClass('shadow');
      calPT.style.display = 'block';
      arr.style.transform = 'rotate(180deg)';
      setTimeout(function () {
        dO.style.background = '#F5F6F5';
        pHol.style.background = '#F5F6F5';
        //...
        calPT.style.opacity = 1;
      }, 10);
    }
  };

  // Pers. Btn
  pN.onclick = function () {
    let opC = $(lFilters).find('.std_filter--pers')[0];
    let pArr = $(pN).find('.std_filters--input--arrow')[0];
    let pHol = $(pN).find('.std_filters--input--pholder')[0];
    if (opC.style.display === 'block') {
      $('.std_filters--inner').removeClass('shadow');
      opC.style.opacity = '';
      setTimeout(function () {
        pN.style.background = '#FFF';
        pArr.style.transform = '';
        pHol.style.background = '';
        opC.style.display = '';
      }, 100);
    } else {
      closeAllPanels();
      $('.std_filters--inner').addClass('shadow');
      opC.style.display = 'block';
      setTimeout(function () {
        pN.style.background = '#F5F6F5';
        pArr.style.transform = 'rotate(180deg)';
        pHol.style.background = '#F5F6F5';
        opC.style.opacity = 1;
      }, 10);
    }
  };

  // Options Btn
  oP.onclick = function () {
    let opC = $(lFilters).find('.std_filter--options')[0];
    if (opC.style.display === 'block') {
      $('.std_filters--inner').removeClass('shadow');
      opC.style.opacity = '';
      setTimeout(function () {
        oP.style.background = '';
        opC.style.display = '';
      }, 100);
    } else {
      closeAllPanels();
      $('.std_filters--inner').addClass('shadow');
      opC.style.display = 'block';
      setTimeout(function () {
        oP.style.background = '#F5F6F5';
        opC.style.opacity = 1;
      }, 10);
    }
  };

  //- Inc Filters Btns
  let incFBtns = $(lFilters).find('.std_filter--inc-btn');
  incFBtns.each(function () {
    let incC = this;
    let incT = incC.getAttribute('data-filter');
    //...
    let input = $(incC).find('.std_filter--inc-input')[0];
    let rem = $(incC).find('.std_filter--rem-btn')[0];
    let add = $(incC).find('.std_filter--add-btn')[0];
    let val = $(incC).find('.std_filter--inc-val')[0];

    // Handle Nums
    function incInc(i) {
      // Get Filter placeholder
      let pHolI = $('[data-filter="' + incT + '-pholder"]')[0];
      let pT = $(pHolI).find('.std_filters--input--title')[0];
      let pV = $(pHolI).find('.std_filters--input--value')[0];
      let pH = $(pHolI).find('.std_filters--input--pholder')[0];

      if (i && pHolI) {
        pH.style.display = 'none';
      }
      //...
      let value = parseInt(val.innerHTML);
      let newVal = value + i;
      if (newVal <= 1) {
        newVal = 1;
        rem.style.opacity = 0.4;
      } else
        rem.style.opacity = '';
      val.innerHTML = newVal;
      input.value = newVal;
      if (i) {
        // Set pHolder
        let pVO = pV.innerHTML;
        let pVOC = pVO.split(' ');
        pV.innerHTML = newVal + ' ' + pVOC[1];
      }
    }

    rem.onclick = function () {
      incInc(-1);
    };
    add.onclick = function () {
      incInc(1)
    };
    // Init
    incInc(0);
  });

  // Items N
  var setChaletNumber = () => {
    setTimeout(() => {
      // Chalets
      let disChalets = 0;
      $('.chalets_list--container a.std_card--fullwidth').each(function () {
        if(!this.style.display)
          disChalets += 1;
      });
      $('.chalets_list--cnt_n').text(disChalets);

      // Chambres
      let disChambres = 0;
      $('.chambres_list--container a.std_card--fullwidth').each(function () {
        if(!this.style.display)
          disChambres += 1;
      });
      $('.chambres_list--cnt_n').text(disChambres);
    }, 300);
  };

  //filter capaciy
  $('.add-pers').on('click', function () {
    let capacity = $('input[name=pers]').val();
    $('a.std_card--fullwidth').filter(function () {
      if (parseInt($(this).attr("data-capacity"), 10) < parseInt(capacity, 10))
        $(this).hide();
    });
    //...
    setChaletNumber();
  });

  $('.rem-pers').on('click', function () {
    let capacity = $('input[name=pers]').val();
    $('a.std_card--fullwidth').filter(function () {
      if (parseInt($(this).attr("data-capacity"), 10) >= parseInt(capacity, 10))
        $(this).show();
    });
    //...
    setChaletNumber();
  });

  // Filter bathrooms
  $('.add-baths').on('click', function () {
    let bathrooms = $('input[name=sb]').val();
    $('a.std_card--fullwidth').filter(function () {
      if ($(this).attr("data-bathrooms") < bathrooms) {
        $(this).hide();
      }
    });
    //...
    setChaletNumber();
  });

  $('.rem-baths').on('click', function () {
    let bathrooms = $('input[name=sb]').val();
    $('a.std_card--fullwidth').filter(function () {
      if ($(this).attr("data-bathrooms") >= bathrooms) {
        $(this).show();
        //...
        setChaletNumber();
      }
    });
    //...
    setChaletNumber();
  });

  // Filter Bedrooms
  $('.add-bedrooms').on('click', function () {
    let bedrooms = $('input[name=ch]').val();
    $('a.std_card--fullwidth').filter(function () {
      if ($(this).attr("data-bedrooms") < bedrooms) {
        $(this).hide();
      }
    });
    //...
    setChaletNumber();
  });

  $('.rem-bedrooms').on('click', function () {
    let bedrooms = $('input[name=ch]').val();
    $('a.std_card--fullwidth').filter(function () {
      if ($(this).attr("data-bedrooms") >= bedrooms) {
        $(this).show();
      }
    });
    //...
    setChaletNumber();
  });
}

window.addEventListener('click', function (e) {
  let filPanles = $('.std_filter--panel');
  filPanles.each(function () {
    // TODO: Close all filters's panels if the click outside a panel
    //console.log(e.currentTarget);
  });
}, true);


// Filter Tags Close
let deskFilOptions = $('.std_filters--options-bottom, .mob_filters--form-checkboxs');
// Get Selected Option
deskFilOptions.each(function () {
  let checkboxs = $('.options_bottom--checkbox, .mob_filters--form-checkbox');

  checkboxs.each(function () {
    let inp = $(this).find('input');
    inp.change(function () {
      let option = inp.attr('id');
      if (inp.is(":checked")) {
        $('div.filters_tags--title').removeAttr('style');
        $('div.filters_tag--item.' + option).removeAttr('style');
        $("a.std_card--fullwidth:not(." + option + ")").hide();
        $('.chalets_list--cnt_n').text($("a.std_card--fullwidth[style='']").length);
      } else {
        if ($('input[name="options[]"]:checked').length === 0) {
          $('div.filters_tags--title').hide();
        }
        $('.filters_tag--item_close#' + option).trigger("click");
      }

      setChaletNumber();
    });
  });
});


// Type select checkboxes
let typeSelect = $('.type_select--checkbox input');
// Get Selected Option
typeSelect.change(function () {
  let checkbox = $(this)[0];
  let value = checkbox.value;
  let checked = checkbox.checked;
  if (value == "chalets") {
    $('.chalets_list--container').css('display',checked ? 'block' : 'none');
  } else if (value == "chambres") {
    $('.chambres_list--container').css('display',checked ? 'block' : 'none');
  }
});


$('body').on('click', '.filters_tag--item_close', function (e) {
  let removed_option = $(this).attr('id');
  let pC = $(this).parent();
  if (e.currentTarget.nodeName.toUpperCase() === 'DIV') {
    pC.css('opacity', '0');
    setTimeout(function () {
      pC.hide();
      $('input.filled-in[value=' + removed_option + ']').prop('checked', false);
      let selected_options = $('input[name="options[]"]:checked');
      let selected_options_classes = '';
      selected_options.map(function () {
        selected_options_classes += '.' + this.id;
      });
      $("a.std_card--fullwidth:not(." + removed_option + ")" + selected_options_classes).show();
      if ($('input[name="options[]"]:checked').length === 0) {
        $('div.filters_tags--title').hide();
      }
      $('.chalets_list--cnt_n').text($("a.std_card--fullwidth[style='']").length);
    }, 300);
  }
});


$('.home_hero--filters .input-daterange, .std_mob--filters .input-daterange').datepicker({
  maxViewMode: 0,
  inputs: $('.from_date, .to_date'),
  format: 'yyyy-mm-dd',
  language: locale,
  multidate: false,
  startDate: new Date()
}).on('changeDate', function (e) {
  let day, month, year, dateTo, dateFrom;
  // disable old days
  //...
  if (calTypeI) {
    // To
    dateTo = e.date;
    if (typeof dateTo === 'undefined') {
      day = NaN;
      month = NaN;
      year = NaN;
    }
    else {
      day = dateTo.getDate();
      month = dateTo.getMonth();
      year = dateTo.getFullYear();
    }
  } else {
    // From
    dateFrom = e.date;

    // var endDate = new Date(e.date);
    // endDate.setDate(e.date.getDate() + 1);
    // console.log(e.date);
    // console.log(endDate);

    $('.to_date').datepicker('setStartDate', e.date);

    if (typeof dateFrom === 'undefined') {
      day = NaN;
      month = NaN;
      year = NaN;
    }
    else {
      day = dateFrom.getDate();
      month = dateFrom.getMonth();
      year = dateFrom.getFullYear();
    }
  }



  // Test if not valid
  if ((dateTo <= dateFrom) && dateFrom && dateTo) {
    //console.log('fuck no');
  } else {
    // * is ok
    // Populate pHolder
    let dI = $(lFilters).find('.std_filters--input-di')[0];
    let dO = $(lFilters).find('.std_filters--input-do')[0];
    let dIP = $(dI).find('.std_filters--input--pholder')[0];
    let dIV = $(dI).find('.std_filters--input--value')[0];
    let dOP = $(dO).find('.std_filters--input--pholder')[0];
    let dOV = $(dO).find('.std_filters--input--value')[0];
    //...
    let disDate = day + ' ' + $.fn.datepicker.dates[locale].months[month];
    month = ('0' + (month + 1)).slice(-2);
    day = ('0' + day).slice(-2);
    let finDate = year + '-' + month + '-' + day;
    //...
    if (calTypeI) {
      // To
      if (Number.isNaN(day))
        dOP.style.display = 'block';
      else {
        dOP.style.display = 'none';
        dOV.innerHTML = disDate;
        // Populate the input
        let calInpT = $('.std_filter--calender-input_t')[0];
        calInpT.value = finDate;
      }
    } else {
      // From
      if (Number.isNaN(day))
        dIP.style.display = 'block';
      else {
        dIP.style.display = 'none';
        dIV.innerHTML = disDate;
        // Populate the input
        let calInpF = $('.std_filter--calender-input_f')[0];
        calInpF.value = finDate;
      }
    }
  }
});

$(".std_mob--filters form, .std_filters form").submit(function( e ) {
  var $form = $(e.target);
  var from = $form.find('input[name="from"]').val();
  var to = $form.find('input[name="to"]').val();
  var pers = $form.find('input[name="pers"]').val();
  window.sessionStorage.setItem('date_from', from);
  window.sessionStorage.setItem('date_to', to);
  window.sessionStorage.setItem('pers', pers);
});

//- DatePicker
if ($('.home_hero--filters').length) {
  $('.from_date .datepicker').on('click', '.day:not(.disabled)', function () {
    setTimeout(function () {
      $('.std_filters--input-do').trigger('click');
    }, 20);
  });

  $('.to_date  .datepicker').on('click', '.day:not(.disabled)', function () {
    setTimeout(function () {
      $('.std_filters--input-pn').trigger('click');
    }, 20);
  });
}

// Filter Mobile

//- Inc Filters Btns
let mobFilters = $('.std_mob--filters');
let incFBtnsMob = $(mobFilters).find('.std_filter--inc-btn-mob');
incFBtnsMob.each(function () {
  let incC = this;
  let incT = incC.getAttribute('data-filter');
  //...
  let input = $(incC).find('.std_filter--inc-input')[0];
  let rem = $(incC).find('.std_filter--rem-btn')[0];
  let add = $(incC).find('.std_filter--add-btn')[0];
  let val = $(incC).find('.std_filter--inc-val')[0];

  // Handle Nums
  function incInc(i) {
    // Get Filter placeholder
    let pHolI = $('[data-filter="' + incT + '-pholder"]')[0];
    let pT = $(pHolI).find('.std_filters--input--title')[0];
    let pV = $(pHolI).find('.std_filters--input--value')[0];
    let pH = $(pHolI).find('.std_filters--input--pholder')[0];

    if (i && pHolI) {
      pH.style.display = 'none';
    }
    //...
    let value = parseInt(val.innerHTML);
    let newVal = value + i;
    if (newVal <= 1) {
      newVal = 1;
      rem.style.opacity = 0.4;
    } else
      rem.style.opacity = '';
    val.innerHTML = newVal;
    input.value = newVal;
    if (i) {
      // Set pHolder
      let pVO = pV.innerHTML;
      let pVOC = pVO.split(' ');
      pV.innerHTML = newVal + ' ' + pVOC[1];
    }
  }

  rem.onclick = function () {
    incInc(-1);
  };
  add.onclick = function () {
    incInc(1)
  };
  // Init
  incInc(0);

});

$('.collapsible-header').each(function(){
   if($(this).hasClass('active')){
      $(this).attr('data-label', $(this).attr('data-label') + " -");
   }else {
      $(this).attr('data-label', $(this).attr('data-label') + " +");
   }
})
$('.collapsible-header').on('click', function(){
  var label = $(this).attr('data-label');
  if($(this).hasClass('active')){
    label.slice(0, -2);
     $(this).attr('data-label', $(this).attr('data-label') + " +");
  }else {
     label.slice(0, -2);
    $(this).attr('data-label', $(this).attr('data-label') + " -");

  }

})
// Mobile Filter Calendar
let calTypeIMob;
let mobFromB = $('.mob_cal--from-f .collapsible-header')[0];
if (mobFromB) {
  mobFromB.onclick = function () {
    calTypeIMob = false;
  };
}

let mobToB = $('.mob_cal--from-t .collapsible-header')[0];
if (mobToB) {
  mobToB.onclick = function () {
    calTypeIMob = true;
  };
}

$('.input-daterange-mob').datepicker({
  maxViewMode: 0,
  inputs: $('.from_date--mob, .to_date--mob'),
  format: 'yyyy-mm-dd',
  language: locale,
  multidate: true,
  startDate: new Date()
}).on('changeDate', function (e) {
  let day, month, dateTo, dateFrom;
  if (calTypeIMob) {
    // To
    dateTo = e.date;
    if (typeof dateTo === 'undefined') {
      day = NaN;
    }
    else {
      day = dateTo.getDate();
    }
  } else {
    // From
    dateFrom = e.date;
    if (typeof dateFrom === 'undefined') {
      day = NaN;
    }
    else {
      day = dateFrom.getDate();
    }
  }

  // Test if not valid
  if ((dateTo <= dateFrom) && dateFrom && dateTo) {
    //console.log('fuck no');
  } else {
    // * is ok
    let mobCalForm = $('.std_mob--filters-form');
    if (calTypeIMob) {
      // To
      if (!(Number.isNaN(day))) {
        let calInpF = $(mobCalForm).find('.std_filter--calender-input--mob_t')[0];
        calInpF.value = e.format();
      }
    } else {
      // From
      if (!(Number.isNaN(day))) {
        let calInpF = $(mobCalForm).find('.std_filter--calender-input--mob_f')[0];
        calInpF.value = e.format();
      }
    }
  }
});


//- DatePicker
if ($('.std_mob--filters').length) {
  $('.from_date--mob .datepicker').on('click', '.day:not(.disabled)', function () {
    setTimeout(function () {
      $('.mob_cal--from-t .collapsible-header').trigger('click');
    }, 20);
  });

  $('.to_date--mob  .datepicker').on('click', '.day:not(.disabled)', function () {
    setTimeout(function () {
      $('.mob_pn .collapsible-header').trigger('click');
    }, 20);
  });
}